export default function Legacy() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div className="absolute -top-4 -right-4 w-32 h-32 rounded-full bg-accent/20 blur-2xl" />
          <div className="relative rounded-[2rem] overflow-hidden aspect-[5/4] soft-shadow">
            <img
              src="https://images.unsplash.com/photo-1706200637521-b446bd05df0d"
              alt="Generations holding hands"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-6">
          <p className="overline mb-4">Why we exist</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-primary leading-[1.05] mb-8">
            Some promises<br />
            <em className="not-italic text-accent">outlive us.</em>
          </h2>
          <p className="text-base sm:text-lg leading-relaxed text-muted-foreground mb-6">
            Faith Family Finance was founded by a husband-and-wife team after watching too many
            families struggle through grief and paperwork at the same time. We believe a good life
            insurance policy is one of the most loving gifts you can leave behind.
          </p>
          <p className="text-base leading-relaxed text-muted-foreground mb-10">
            That&rsquo;s why we&rsquo;re independent. That&rsquo;s why we explain everything. That&rsquo;s why our agents
            stay with you for life &mdash; and beyond.
          </p>

          <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border/60">
            <div>
              <p className="font-serif text-4xl text-primary">25+</p>
              <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground mt-1">A-rated carriers</p>
            </div>
            <div>
              <p className="font-serif text-4xl text-primary">12k</p>
              <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground mt-1">Families served</p>
            </div>
            <div>
              <p className="font-serif text-4xl text-primary">98%</p>
              <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground mt-1">Claim approval</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
